// House of Shaba clone — global behaviours (cart drawer hold timer + one-click adds from drawer rows)
(function () {
  var KEY = 'shHoldEnd';
  setInterval(function () {
    var el = document.querySelector('[data-sh-hold]'); if (!el) return;
    var end = +sessionStorage.getItem(KEY);
    if (!end || end < Date.now() - 60000) { end = Date.now() + 240000; sessionStorage.setItem(KEY, end); }
    var d = Math.max(0, end - Date.now());
    el.textContent = Math.floor(d / 60000) + ':' + ('0' + Math.floor(d % 60000 / 1000)).slice(-2);
  }, 1000);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sh-add]'); if (!b) return;
    b.disabled = true; b.textContent = '…';
    fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.shAdd, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { return r.json(); }).then(function (j) {
      var d = document.querySelector('cart-drawer');
      if (d && d.renderContents) { j.id = +b.dataset.shAdd; d.renderContents(j); } else { location.reload(); }
    });
  });
})();

// shipping insurance toggle in the cart drawer (adds / removes the insurance line, then re-renders the drawer)
document.addEventListener('change', function (e) {
  var c = e.target.closest('[data-sh-ins]'); if (!c) return;
  var body = c.checked ? { items: [{ id: +c.dataset.shIns, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }
                       : { id: c.dataset.key, quantity: 0, sections: 'cart-drawer,cart-icon-bubble' };
  fetch(c.checked ? '/cart/add.js' : '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
    .then(function (r) { return r.json(); }).then(function (j) {
      var d = document.querySelector('cart-drawer');
      if (j.sections && d && d.renderContents) { j.id = +c.dataset.shIns; d.renderContents(j); } else { location.reload(); }
    });
});

// size guide: sit on the same line as the variant picker's "Size" label when a picker is shown
document.addEventListener('DOMContentLoaded', function () {
  var link = document.querySelector('.sh-sg-link'); if (!link) return;
  var label = document.querySelector('variant-selects legend, variant-selects .form__label, .product-form__input legend');
  if (label) { link.classList.add('is-inline'); label.style.display = 'flex'; label.style.justifyContent = 'space-between'; label.style.alignItems = 'center'; label.style.width = '100%'; label.appendChild(link); var w = document.querySelector('.sh-sg-wrap'); if (w) w.style.display = 'none'; }
});
